<div style="min-height:70vh">
    <router-outlet></router-outlet>
</div>